import { Injectable } from '@angular/core';
import { Router, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ContentAssignmentWizardService } from "../_services/content-assignment-wizard.service";

@Injectable()
export class LMSContentAssignmentWizardStepGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private wizardService: ContentAssignmentWizardService
  ) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const step = childRoute.url[0]?.path;
    const orgId = childRoute.paramMap.get('organizationId');
    const step1Route = ['/organizations', orgId, 'admin', 'learning', 'assignments', 'create', 'content'];

    switch(step) {
      case 'content':
        // First step - always allowed (permission already checked at parent)
        return true;

      case 'employees':
        if (!this.wizardService.canProceedToEmployees()) {
          this.router.navigate(step1Route);
          return false;
        }
        return true;

      case 'details':
        if (!this.wizardService.canProceedToDetails()) {
          this.router.navigate(step1Route);
          return false;
        }
        return true;

      default:
        return true;
    }
  }
}
